import { createSlice } from "@reduxjs/toolkit";
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

const INIT_STATE = {
    openModal: false,
    type: null,
    accountId: null,
    entities: []
};

const route = "accounts/views/components/syncEntities/.components/entitySelector/redux/slice";

export const getAsset = async (input = '', accountId) => {
    try {
        let QUERY = `
        query searchAssets ($conditions: [AssetSearchInput], $sort: [AssetSortInput], $limit: Int, $offset: Int) {
            result: searchAssets (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                }
            }
        }`
        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["companyId"],
                    terms: [accountId],
                    exact: true
                },
                {
                    fields: ["label"],
                    terms: [input],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "label",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        return data?.result?.items || []

    } catch (exc) {
        ExceptionManager(exc, route, 'getAsset');
    }
}
export const getAssetSubtype = async (input = '', accountId) => {
    try {
        let QUERY = `
        query searchAssetSubtypes ($conditions: [AssetSubtypeSearchInput], $sort: [AssetSubtypeSortInput], $limit: Int, $offset: Int) {
            result: searchAssetSubtypes (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }   
            }
        }`

        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["companyId"],
                    terms: [accountId],
                    exact: true
                },
                {
                    fields: ["name"],
                    terms: [
                        input
                    ],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "name",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        if (data?.result?.items?.length > 0) {
            return data.result.items.map(item => ({ ...item, label: item.name })) || []
        } else return []

    } catch (exc) {
        ExceptionManager(exc, route, 'getAssetSubtype');
    }
}

export const getSubUser = async (input = '', accountId) => {
    try {
        let QUERY = `
        query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
            result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    userName
                }   
            }
        }`
        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["companyId"],
                    terms: [accountId],
                    exact: true
                },
                {
                    fields: ["userName"],
                    terms: [
                        input
                    ],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "userName",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        if (data?.result?.items?.length > 0) {
            return data.result.items.map(item => ({ ...item, label: item.userName })) || []
        } else return []

    } catch (exc) {
        ExceptionManager(exc, route, 'getSubUser');
    }
}

export const getDriver = async (input = '', accountId) => {
    try {
        let QUERY = `
        query searchDrivers ($conditions: [DriverSearchInput], $sort: [DriverSortInput], $limit: Int, $offset: Int) {
            result: searchDrivers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }   
            }
        }`
        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["companyId"],
                    terms: [accountId],
                    exact: true
                },
                {
                    fields: ["name"],
                    terms: [
                        input
                    ],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "name",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        if (data?.result?.items?.length > 0) {
            return data.result.items.map(item => ({ ...item, label: item.name })) || []
        } else return []

    } catch (exc) {
        ExceptionManager(exc, route, 'getDriver');
    }
}

export const getUnit = async (input = '', accountId) => {
    try {
        let QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                }   
            }
        }`
        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["companyId"],
                    terms: [accountId],
                    exact: true
                },
                {
                    fields: ["label"],
                    terms: [
                        input
                    ],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "label",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        return data?.result?.items || []

    } catch (exc) {
        ExceptionManager(exc, route, 'getUnit');
    }
}

export const getAssetTypes = async (input = '') => {
    try {
        let QUERY = `
        query searchEntityLists ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
            result: searchEntityLists (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                }   
            }
        }`
        let data = await clientQuery(QUERY, {
            conditions: [
                {
                    fields: ["entityName"],
                    terms: ["AssetType"],
                    exact: true
                },
                {
                    fields: ["label"],
                    terms: [
                        input
                    ],
                    exact: false
                }
            ],
            sort: [
                {
                    field: "label",
                    order: "ASC"
                }
            ],
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        return data?.result?.items || []

    } catch (exc) {
        ExceptionManager(exc, route, 'getAssetTypes');
    }
}


export const syncEntitiesSelectorRedux = createSlice({
    name: 'accounts/views/components/syncEntities',
    initialState: INIT_STATE,
    reducers: {
        resetEntitySelector(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalEntitySelector(state, action) {
            state.openModal = true
            state.entities = action.payload?.entities || [];
            state.type = action.payload?.type || null;
            state.accountId = action.payload?.accountId || null;
        }
    },
    extraReducers: (builder) => {

    }
})

const { actions, reducer } = syncEntitiesSelectorRedux;

// Extract and export each action creator by name
export const {
    resetEntitySelector,
    openModalEntitySelector
} = actions;

export default reducer;
